export default {"src":"https://images-cdn.curipod.com/d-0e1143a7/_next/static/media/curiLogo.0c0d49a5.svg","height":298,"width":299};